<div class="container-fluid">
  <div class="page-head">
    <h5 class="header-title heading-color">Default Payout Percentage</h5>
  </div>
  <div class="row">
    <div class="col-lg-12">
      <div class="card m-b-30">
        <form [formGroup]="defaultPayoutForm">
          <div class="card-body">
            <div class="row">
              <h6 class="col-lg-12 text-center ">ENTER DEFAULT PAYOUT PERCENTAGE</h6>
            </div>
            <br>
            <div class="row">
              <div class="col-md-2"> </div>
              <div class="col-md-4">
                <input type="number" min="0" max="100" formControlName="consultation_share" class="form-control select"
                  placeholder="Enter Default Payout Percentage" />

                <span *ngIf="defaultPayoutForm.get('consultation_share').hasError('required')" class="invalid-feedback">
                  Default Payout Percentage is required
                </span>
              </div>
              <div class="col-md-4 text-center">
                <button type="submit" name="find" class="btn btn-primary text-white"
                  [disabled]="!defaultPayoutForm.valid" (click)="updatePercentage()">Update</button>
              </div>
            </div>
          </div>
        </form>

      </div>
    </div>
  </div>